  import type { RuleObject } from "antd/lib/form";
import type { StoreValue } from "antd/lib/form/interface";
import { parsePhoneNumberWithError } from "libphonenumber-js/max";

export const requireCountryCodeAndPhoneNumber = (
  getFieldValue: (name: string) => any,
  countryCodeFieldName: string,
  phoneNumberFieldName: string
) => ({
  validator(_: RuleObject, value: StoreValue) {
    const countryCode = getFieldValue(countryCodeFieldName);
    const phoneNumber = getFieldValue(phoneNumberFieldName);

    if ((phoneNumber && String(phoneNumber).trim()) && !countryCode) {
      return Promise.reject(new Error("Country code is required"));
    }

    if (countryCode && (!phoneNumber || String(phoneNumber).trim() === "")) {
      return Promise.reject(new Error("Phone number is required"));
    }

    if (countryCode && phoneNumber) {
      try {
        const parsedPhoneNumber = parsePhoneNumberWithError(
          String(phoneNumber),
          {
            defaultCallingCode: countryCode,
          }
        );
        if (!parsedPhoneNumber.isValid()) {
          return Promise.reject(new Error("Invalid phone number for selected country"));
        }
      } catch {
        return Promise.reject(new Error("Invalid phone number for selected country"));
      }
    }
    return Promise.resolve();
  },
});
